import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { UtensilsCrossed, MessageSquare, Mail, Image as ImgIcon, Globe, Gift } from "lucide-react";
import EventSourcesPanel from "@/pages/admin/EventSourcesPanel";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ dishes: 0, categories: 0, events: 0, messages: 0, gallery: 0, seo: 0, giftcards: 0, revenue: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [c, d, e, m, g, s, gc] = await Promise.all([
          api.get("/menu/categories"),
          api.get("/menu/dishes"),
          api.get("/events/requests"),
          api.get("/contact/messages"),
          api.get("/gallery"),
          api.get("/seo-pages"),
          api.get("/admin/giftcards/stats"),
        ]);
        setStats({
          categories: c.data.length, dishes: d.data.length, events: e.data.length,
          messages: m.data.length, gallery: g.data.length, seo: s.data.length,
          giftcards: gc.data.total_sold || 0, revenue: gc.data.total_revenue || 0,
        });
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  const cards = [
    { label: "Plats", value: stats.dishes, icon: UtensilsCrossed, link: "/admin/menu", sub: `${stats.categories} catégories` },
    { label: "Cartes Cadeaux vendues", value: stats.giftcards, icon: Gift, link: "/admin/giftcards", sub: `${stats.revenue.toLocaleString("fr-FR")} € de CA` },
    { label: "Demandes d'événements", value: stats.events, icon: MessageSquare, link: "/admin/events" },
    { label: "Messages contact", value: stats.messages, icon: Mail, link: "/admin/messages" },
    { label: "Galerie", value: stats.gallery, icon: ImgIcon, link: "/admin/gallery" },
    { label: "Pages SEO", value: stats.seo, icon: Globe, link: "/admin/seo" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <p className="overline">Vue d'ensemble</p>
      <h1 className="font-display text-4xl md:text-5xl mt-3">Tableau de bord</h1>
      <p className="text-[#697585] mt-3">Gérez votre site et la carte du restaurant.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {cards.map((c) => (
          <Link key={c.label} to={c.link} data-testid={`dash-card-${c.label}`} className="block p-6 border border-[#D9D3C5] bg-[#FFFFFF] hover:border-[#B8956A]/50 transition-colors group">
            <div className="flex items-start justify-between">
              <div>
                <p className="overline">{c.label}</p>
                <p className="font-display text-5xl mt-3 text-[#203240]">{c.value}</p>
                {c.sub && <p className="text-xs text-[#697585] mt-2">{c.sub}</p>}
              </div>
              <c.icon size={24} className="text-[#B8956A] group-hover:scale-110 transition-transform" />
            </div>
          </Link>
        ))}
      </div>

      <EventSourcesPanel />
    </div>
  );
}
